import React, { useState } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { colors } from '../constants';
export const ToggleButtons = _ref => {
  let {
    type,
    active,
    disabled,
    externalToggleStyles,
    setToggleState
  } = _ref;
  const {
    toggleContainerStyle,
    toggleBackgroundActiveStyle,
    toggleButtonActiveStyle,
    toggleBackgroundInactiveStyle,
    toggleButtonInactiveStyle,
    toggleButtonDisabledStyle
  } = externalToggleStyles || {};
  const [toggle, setToggle] = useState(active);
  function handlePressToggleButton() {
    const currentValue = toggle;
    if (setToggleState) {
      setToggleState(!currentValue);
    }
    setToggle(!currentValue);
  }
  const disabledIconColor = toggle ? colors.amethyst300 : colors.neutral200;
  const getButtonSize = t => {
    switch (t) {
      case 'large':
        return {
          width: 72,
          height: 40
        };
      case 'medium':
        return {
          width: 56,
          height: 32
        };
      case 'small':
      default:
        return {
          width: 44,
          height: 24
        };
    }
  };
  const getIconContainerSize = t => {
    switch (t) {
      case 'large':
        return {
          width: 32,
          height: 32
        };
      case 'medium':
        return {
          width: 24,
          height: 24
        };
      case 'small':
      default:
        return {
          width: 16,
          height: 16
        };
    }
  };
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.container, toggleContainerStyle]
  }, /*#__PURE__*/React.createElement(TouchableOpacity, {
    style: [styles.buttonContainer, {
      backgroundColor: toggle ? colors.amethyst400 : colors.neutral300,
      ...getButtonSize(type),
      ...(toggle ? {
        alignItems: 'flex-end'
      } : {
        alignItems: 'flex-start'
      })
    }, toggle ? toggleBackgroundActiveStyle : toggleBackgroundInactiveStyle],
    onPress: handlePressToggleButton,
    activeOpacity: 1,
    disabled: !!disabled
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.iconContainer, {
      ...{
        backgroundColor: disabled ? disabledIconColor : colors.neutral0
      },
      ...getIconContainerSize(type)
    }, toggle ? toggleButtonActiveStyle : toggleButtonInactiveStyle, disabled ? toggleButtonDisabledStyle : {}]
  })));
};
const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    borderRadius: 16
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 4,
    borderRadius: 12
  }
});
//# sourceMappingURL=ToggleButtons.js.map